import api from "../../../api";

export const getDossiers = async (filters = {}, config = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append("status", filters.status);
  if (filters.type) params.append("type", filters.type);
  if (filters.priority) params.append("priority", filters.priority);
  if (filters.search) params.append("search", filters.search);
  
  const response = await api.get(`/operation-cases?${params.toString()}`, config);
  return response.data;
};

export const getDossierById = async (id) => {
  const response = await api.get(`/operation-cases/${id}`);
  return response.data;
};

export const createDossier = async (data) => {
  const response = await api.post("/operation-cases", data);
  return response.data;
};

export const updateDossier = async (id, data) => {
  const response = await api.patch(`/operation-cases/${id}`, data);
  return response.data;
};

export const postDecision = async (id, data) => {
  const response = await api.post(`/operation-cases/${id}/decision`, data);
  return response.data;
};

export const convertDossier = async (id) => {
  const response = await api.post(`/operation-cases/${id}/convert`);
  return response.data;
};

export const addParticipant = async (id, data) => {
  const response = await api.post(`/operation-cases/${id}/participants`, data);
  return response.data;
};

export const updateParticipant = async (caseId, participantId, data) => {
  const response = await api.put(`/operation-cases/${caseId}/participants/${participantId}`, data);
  return response.data;
};

export const deleteParticipant = async (caseId, participantId) => {
  const response = await api.delete(`/operation-cases/${caseId}/participants/${participantId}`);
  return response.data;
};

export const uploadDocument = async (caseId, file, category, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  if (category) {
    formData.append('category', category);
  }
  
  const response = await api.post(`/operation-cases/${caseId}/documents`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
      }
    }
  });
  return response.data;
};

export const deleteDocument = async (caseId, documentId) => {
  const response = await api.delete(`/operation-cases/${caseId}/documents/${documentId}`);
  return response.data;
};
